// Vue router
import Vue from 'vue';
import VueRouter from 'vue-router';
// Profile Main component
import Main from '../Main';
// Data
import profileSectionRoutes from './profileSectionRoutes';

// Use vue plugin: vue router
Vue.use(VueRouter);

// Common route creation methods
const importFn = path => () => import(`@/scripts/Components/Organisms/Profile/ProfileSection/${path}`);
const makeRoute = (routeDefinition) => {
  const { component, children } = routeDefinition;
  return {
    ...routeDefinition,
    component: (typeof component === 'string')
      ? importFn(component)
      : component,
    children: children ? children.map(makeRoute) : undefined,
  };
};

// Common children route
const commonChildren = [
  ...profileSectionRoutes.map(makeRoute),
  { path: '*', meta: { requestedTab: false } },
];

export default new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/profile',
      component: Main,
      children: commonChildren,
    },
    { path: '/u/:id',
      component: Main,
      children: commonChildren,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.meta.requestedTab) {
      return {
        selector: '#profile-section-anchor',
        offset: { x: 0, y: 58 },
      };
    } else {
      return { x: 0, y: 0 };
    }
  },
});
